import { Table, Tbody, Tr, Th, Td, Thead, Box } from "@chakra-ui/react";
import "./referenceTable.css";

export default function ReferenceTable() {
  const style = {
    color: "white",
    size: "md",
    fontSize: "18px",
    fontFamily: "Fjord One",
    background: "rgba(31, 159, 181, 0.3)",
  };
  return (
    <Box
      className='reference-table'
      color='white'
      display='flex'
      flexDir='column'
      alignItems='center'
      width={{ base: "100%", md: "80%", xl: "90%" }}
      mx='auto'
      borderRadius='sm'
      mb={2}
    >
      <Table
        variant='simple'
        display={{ base: "block", md: "table", xl: "table" }}
        style={{
          ...style,
          overflowX: "auto",
        }}
      >
        <Thead style={style}>
          <Tr>
            <Th style={style}>1</Th>
            <Th style={style}>POST SCORE</Th>
            <Th style={style}>AB/BC</Th>
            <Th style={style}>Value</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr style={style}>
            <Td rowSpan='2'>2</Td>
            <Td rowSpan='2'>Urethral Plate quality </Td>
            <Td>POST &#8805; 1.2</Td>
            <Td>Favorable</Td>
          </Tr>
          <Tr style={style}>
            <Td>POST &#60; 1.2</Td>
            <Td>Unfavorable</Td>
          </Tr>
          <Tr style={style}>
            <Td rowSpan='4'>3</Td>
            <Td rowSpan='4'>Procedure suggested</Td>
            <Td>POST &#8805; 1.4</Td>
            <Td>Duplay Procedure</Td>
          </Tr>
          <Tr style={style}>
            <Td>POST 1.4 &gt; -1.2</Td>
            <Td>TIP Procedure</Td>
          </Tr>
          <Tr style={style}>
            <Td>POST 1.19-0.7</Td>
            <Td>Dorsal Inlay TIP Procedure</Td>
          </Tr>
          <Tr style={style}>
            <Td>POST &lt; 0.7</Td>
            <Td>Staged ureThroplasty</Td>
          </Tr>

          <Tr style={style}>
            <Td rowSpan='4'>4</Td>
            <Td rowSpan='4'>Complication Rate</Td>
            <Td>POST &gt; 1.2</Td>
            <Td>5-10%</Td>
          </Tr>
          <Tr style={style}>
            <Td>POST 1.2 &gt; -0.7</Td>
            <Td>10-15%</Td>
          </Tr>
          <Tr style={style}>
            <Td>POST 0.5-&lt;0.7</Td>
            <Td>15-20%</Td>
          </Tr>
          <Tr style={style}>
            <Td>POST &lt; 0.5</Td>
            <Td>&gt;20%</Td>
          </Tr>
        </Tbody>
      </Table>
    </Box>
  );
}
